import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  Categories,
  Departments,
  Labels,
  ProductionHistory,
} from '../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import { CustomToastsService } from '../../../Services/custom-toasts.service';
import { BreadcrumbService } from '../../../Services/breadcrumb.service';
import { QzTrayService } from '../../../qz-tray.service';
import { WeekColorService } from '../../admin-module/company-config/WeekColors/services/week-color.service';
import { userInfo } from 'os';
import { ProductionCycle } from '../../admin-module/company-config/WeekColors/models/week-color.model';
import { LabelEntityType } from 'src/app/Services/enum';

@Component({
  selector: 'app-new-entry',
  templateUrl: './new-entry.component.html',
  styleUrls: ['./new-entry.component.css'],
})
export class NewEntryComponent {
  @ViewChild('tagButton') tagButton?: ElementRef<HTMLElement>;

  weekColorsList: Array<ProductionCycle> = [];
  labels: Array<Labels> = [];
  production: ProductionHistory = new ProductionHistory();
  printersList: Array<string> = [];
  printMode: boolean = false;
  showModal: boolean = false;
  tagClr: string = '';
  tagDept: string = '';
  tagCtg: string = '';
  tagSize: string = '';
  tagPrice: string = '';
  tagID: number = 0;
  SerialId: string = '';
  qty: number = 0;
  departments: Array<Departments> = [];
  categories: Array<Categories> = [];
  isDept: boolean = true;
  isCatg: boolean = true;
  isSize: boolean = true;
  showWeekColor: boolean = true;

  constructor(
    private masterservice: MasterDataSeriveService,
    private toastr: CustomToastsService,
    private breadcrumbService: BreadcrumbService,
    private toaster: ToastrService,
    private printService: QzTrayService,
    private weekColorService: WeekColorService
  ) { }

  ngOnInit() {
    const user = this.masterservice.getUserDetailsFromStorage();
    const productionScheduleType = (user?.productionScheduleType ?? '')
      .toString()
      .trim()
      .toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';

    this.getPrintersList();
    this.printService.initQZ();
    this.breadcrumbService.updateActiveDeptTab('Home');
    this.breadcrumbService.updateActiveCategoryTab('Bulk Item Entry');
    this.getWeekColors();
    this.getlabels();
    this.getdepartments();
    // this.getCategories();
  }
  resetFileds(id: number) {
    if (id == 1 || id == 7) {
      this.isDept = true;
      this.isCatg = true;
      this.isSize = true;
    } else if (id == 2) {
      this.isDept = true;
      this.isCatg = false;
      this.isSize = false;
      this.production.sizeDescr = '';
    } else {
      this.isSize = false;
      this.production.sizeDescr = '';
    }
  }

  toggleDesc(e: any) { }
  triggerTagButtonClick() {
    if (this.tagButton) {
      this.tagButton.nativeElement.click();
    }
  }

  getdepartments() {
    this.masterservice.getMainDepartments().subscribe((res) => {
      this.departments = res as Departments[];
    });
  }

  getCategories() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice
      .getCategoriesByDeptUserID(
        this.production.departmentId,
        user.userId,
        false,
        0
      )
      .subscribe((res) => {
        this.categories = res as Categories[];
      });
  }
  showSuccess() {
    this.toastr.success('Printing...');
  }
  async getPrintersList() {
    await this.printService.getPrinters().subscribe((res) => {
      this.printersList = res as string[];
    });
  }

  printProduction(data: ProductionHistory) {
    this.qty = data.qty;
    const selectedColor = this.weekColorsList.find(
      (c) => c.id == data.productionCycleId
    );
    const selectedCatg = this.categories.find(
      (c) => c.categoryId == data.categoryId
    );
    this.tagID = data.formatTypeId;
    this.tagClr = selectedColor ? selectedColor.displayName : 'N/A';
    this.tagDept = data.departmentDescr || 'N/A';
    this.tagCtg = selectedCatg ? selectedCatg.categoryName : 'N/A';

    this.tagSize = data.sizeDescr || '';
    this.tagPrice = data.price ? data.price.toString() : '0.00';
    this.SerialId = data.barcode || '';
    this.production.color = selectedColor ? selectedColor.color : 'transparent';

    if (this.printMode) {
      this.triggerTagButtonClick();
    } else {
      let user = this.masterservice.getUserDetailsFromStorage();
      data.companyName = user.company;
      data.displayName = this.tagClr;
      data.categoryName = this.tagCtg;

      let zplData: string[] = [];
      if (data.formatTypeId == 1) {
        zplData = this.generateZPLLabel(
          data.companyName,
          data.departmentDescr,
          data.categoryName,
          data.sizeDescr,
          this.tagPrice,
          data.barcode,
          data.displayName
        );
        this.printLabel(zplData);
      } else if (data.formatTypeId == 2) {
        zplData = this.generateZPLTag(
          data.companyName,
          data.categoryName,
          this.tagPrice,
          data.barcode,
          data.displayName
        );
        this.printTag(zplData);
      } else if (data.formatTypeId == 7) {
        zplData = this.generateZPLLabelLandscape(
          data.companyName,
          data.departmentDescr,
          data.categoryName,
          data.sizeDescr,
          this.tagPrice,
          data.barcode,
          data.displayName
        );
        this.printLabel(zplData);
      } else {
        zplData = this.generateSpokane(
          data.companyName,
          data.departmentDescr,
          data.categoryName,
          data.sizeDescr,
          this.tagPrice,
          data.barcode
        );
        this.printLabel(zplData);
      }
      this.showSuccess();
      this.reset();
    }
  }

  reset() {
    this.production = new ProductionHistory();
    this.isDept = true;
    this.isCatg = true;
    this.isSize = true;
    this.tagClr = '';
    this.tagDept = '';
    this.tagCtg = '';
    this.tagSize = '';
    this.tagPrice = '';
    this.SerialId = '';
    this.tagID = 0;
  }
  printbtn() {
    this.printMode = !this.printMode;
  }
  async printTag(data: any) {
    let printerName: string = '';

    if (this.printersList.includes('ZebraTag')) {
      printerName = 'ZebraTag';
    } else {
      printerName = 'ZebraBoth';
    }
    let qty = this.qty;
    for (let i = 0; i < qty; i++) {
      let res = this.printService.printData(printerName, data);
    }
  }

  async printLabel(data: any) {
    let printerName: string = '';

    if (this.printersList.includes('ZebraLabel')) {
      printerName = 'ZebraLabel';
    } else {
      printerName = 'ZebraBoth';
    }
    let qty = this.qty;
    for (let i = 0; i < qty; i++) {
      let res = this.printService.printData(printerName, data);
    }
  }

  generateSpokane(
    company: string,
    dept: string,
    category: string,
    Size: string,
    price: string,
    barcode: string
  ) {
    if (Size) {
      const zpltemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT28,134^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$${price}^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^FT298,135^A0N,23,28^FH\^CI28^FDSize:${Size}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$${price}^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`,
      ];
      return zpltemplate;
    } else {
      let zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0,0`,
        `^JMA`,
        `^PR6,6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0,1,1,0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW559`,
        `^LL203`,
        `^LS0`,
        `^FT53,46^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT28,76^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT28,105^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT158,176^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT28,170^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^FT322,47^A0N,28,30^FH\^CI28^FD${company}^FS^CI27`,
        `^FT298,77^A0N,23,28^FH\^CI28^FD${dept}^FS^CI27`,
        `^FT298,106^A0N,23,28^FH\^CI28^FD${category}^FS^CI27`,
        `^BY1,3,41^FT428,177^BCN,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^FT298,172^A0N,28,35^FH\^CI28^FD$1.99^FS^CI27`,
        `^PQ1,0,1,Y`,
        `^XZ`,
      ];
      return zplTemplate;
    }
  }

  generateZPLLabelLandscape(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string,
    color: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,42,41^FH\^CI28^FD${company}^FS^CI27`,
        `^FT400,158^A0R,28,28^FH\^CI28^FD${color}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDSize : ${size}^FS^CI27`,
        `^FT153,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT153,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT153,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT44,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`,
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        `^XA`,
        `~TA000`,
        `~JSN`,
        `^LT0`,
        `^MNW`,
        `^MTD`,
        `^PON`,
        `^PMN`,
        `^LH0, 0`,
        `^JMA`,
        `^PR6, 6`,
        `~SD15`,
        `^JUS`,
        `^LRN`,
        `^CI27`,
        `^PA0, 1, 1, 0`,
        `^XZ`,
        `^XA`,
        `^MMT`,
        `^PW508`,
        `^LL305`,
        `^LS0`,
        `^FT443,38^A0R,35,34^FH\^CI28^FD${company}^FS^CI27`,
        `^FT400,158^A0R,28,28^FH\^CI28^FD${color}^FS^CI27`,
        `^FT347,38^A0R,35,34^FH\^CI28^FD${department}^FS^CI27`,
        `^FT286,38^A0R,35,34^FH\^CI28^FD${category}^FS^CI27`,
        `^FT222,38^A0R,35,34^FH\^CI28^FDPrice : ^FS^CI27`,
        `^FT222,148^A0R,35,34^FH\^CI28^FD$^FS^CI27`,
        `^FT222,168^A0R,35,34^FH\^CI28^FD${price}^FS^CI27`,
        `^BY1,3,67^FT103,98^BCR,,Y,N`,
        `^FH\^FD>${barcode}^FS`,
        `^PQ1, 0, 1, Y`,
        `^XZ`,
      ];
      return zplTemplate;
    }
  }

  generateZPLLabel(
    company: string,
    department: string,
    category: string,
    size: string,
    price: string,
    barcode: string,
    color: string
  ): string[] {
    if (size != null) {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT250,90^A0N,14,14^FH^CI28^FD${color}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,24,18^FH^CI28^FDSize : ^FS^CI27`,
        `^FT131,248^A0N,24,32^FH^CI28^FD${size} ^FS^CI27`,
        `^FT90,299^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,406^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,377^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ',
      ];
      return zplTemplate;
    } else {
      const zplTemplate: string[] = [
        '^XA',
        '~TA000',
        '~JSN',
        '^LT0',
        '^MNW',
        '^MTD',
        '^PON',
        '^PMN',
        '^LH0,0',
        '^JMA',
        '^PR4,4',
        '~SD15',
        '^JUS',
        '^LRN',
        '^CI27',
        '^PA0,1,1,0',
        '^XZ',
        '^XA',
        '^MMT',
        '^PW305',
        '^LL508',
        '^LS0',
        `^FT35,57^A0N,37,38^FH^CI28^FD${company}^FS^CI27`,
        `^FT250,90^A0N,14,14^FH^CI28^FD${color}^FS^CI27`,
        `^FT54,144^A0N,28,28^FH^CI28^FD${department}^FS^CI27`,
        `^FT90,200^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
        `^FT90,250^A0N,28,38^FH^CI28^FD$ ${price} ^FS^CI27`,
        `^FT102,370^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
        `^BY1,3,61^FT69,330^BCN,,N,N`,
        `^FH^FD>${barcode}^FS`,
        '^PQ1,0,1,Y',
        '^XZ',
      ];
      return zplTemplate;
    }
  }

  generateZPLTag(
    name: string,
    category: string,
    price: string,
    barcode: string,
    color: string
  ): string[] {
    const zplTemplate: string[] = [
      '^XA',
      '~TA000',
      '~JSN',
      '^LT0',
      '^MNW',
      '^MTD',
      '^PON',
      '^PMN',
      '^LH0,0',
      '^JMA',
      '^PR4,4',
      '~SD15',
      '^JUS',
      '^LRN',
      '^CI27',
      '^PA0,1,1,0',
      '^XZ',
      '^XA',
      '^MMT',
      '^PW406',
      '^LL203',
      '^LS0',
      `^FT29,45^A0N,37,38^FH^CI28^FD${name}^FS^CI27`,
      `^FT29,70^A0N,17,18^FH^CI28^FD${color}^FS^CI27`,
      `^FT29,106^A0N,28,28^FH^CI28^FD${category}^FS^CI27`,
      `^FT29,155^A0N,37,38^FH^CI28^FD$ ${price}^FS^CI27`,
      `^FT280,181^A0N,17,18^FH^CI28^FD${barcode}^FS^CI27`,
      '^FT268,150^BON,5,8',
      `^FH^FD${barcode}^FS`,
      '^PQ1,0,1,Y',
      '^XZ',
    ];
    return zplTemplate;
  }

  getWeekColors() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.weekColorService.getProductionCycles(user.companyID).subscribe((res) => {
      this.weekColorsList = res as ProductionCycle[];
    });
  }

  /*  generateZPLData(index: number, data: ProductionHistory) {

      if (index == 1) {
        let zplData = this.generateZPLLabel(data.companyName, data.departmentDescr, data.categoryName, data.sizeDescr, data.price.toString(), data.barcode);
        this.printLabel(zplData);
      } else {
        let zplData = this.generateZPLTag(data.companyName, data.categoryName, data.price.toString(), data.barcode);
        this.printTag(zplData);
      }
    }*/

  getlabels() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice.getAllLabels(user.companyID).subscribe((res) => {
      const data: Labels[] = Array.isArray(res) ? res : [res];

      this.labels = data.filter(
        label => label.labelEntityType === LabelEntityType.Product
      );

    });
  }
}
